module.exports = __webpack_public_path__ + "static/media/phone-icon.8caa42d6.svg";